import * as React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import { AppErrorPage } from "./components/app-error-page";
import { configureApiClient } from "./lib/api-client";
import { routeTree } from "./routeTree.gen";
import "./globals.css";

// Muss vor dem ersten Request laufen.
configureApiClient();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Few concurrent users, so refetching once too often beats showing
      // stale training data.
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Do not retry on 401, otherwise the sign-in form hangs.
        if (error instanceof Error && error.name === "ApiError") return false;
        return failureCount < 2;
      },
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultErrorComponent: AppErrorPage,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root-Element fehlt");

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
